import React, { useState } from 'react';

const ZoneContext = React.createContext();

export const ZoneProvider = (props) => {
  const [zone, setZone] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [adminableBooklets, setAdminableBooklets] = useState([]);
  const [filteredBooklets, setFilteredBooklets] = useState([]);
  const [hiddenBooklets, setHiddenBooklets] = useState([]);
  const [showAllBooklets, setShowAllBooklets] = useState(false);
  const [allBooklets, setAllBooklets] = useState([]);

  // Selected companies in booklet
  const [selectedCompaniesInBooklet, setSelectedCompaniesInBooklet] = useState([]);

  const context = {
    zone,
    companies,
    adminableBooklets,
    filteredBooklets,
    showAllBooklets,
    hiddenBooklets,
    selectedCompaniesInBooklet,
    allBooklets,
    setSelectedCompaniesInBooklet,
    setZone,
    setCompanies,
    setAdminableBooklets,
    setShowAllBooklets,
    setFilteredBooklets,
    setHiddenBooklets,
    setAllBooklets
  };

  return (
    <ZoneContext.Provider value={context}>
      {props.children}
    </ZoneContext.Provider>
  );
};

export const useZoneContext = () => React.useContext(ZoneContext);
